import { render, staticRenderFns } from "./BusinessInfoModal.vue?vue&type=template&id=475c917b&scoped=true&"
import script from "./BusinessInfoModal.vue?vue&type=script&lang=js&"
export * from "./BusinessInfoModal.vue?vue&type=script&lang=js&"
import style0 from "./BusinessInfoModal.vue?vue&type=style&index=0&id=475c917b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "475c917b",
  null
  
)

export default component.exports